export const SEND_SUBSCRIPTION_MAIL = 'SEND_SUBSCRIPTION_MAIL';
export const SET_CHANNELS_SUBSCRIPTION_MAIL_SENT = 'SET_CHANNELS_SUBSCRIPTION_MAIL_SENT';
export const SENDING_CHANNELS_SUBSCRIPTION_MAIL = 'SENDING_CHANNELS_SUBSCRIPTION_MAIL';
export const SEND_CHANNELS_SUBSCRIPTION_ERROR = 'SEND_CHANNELS_SUBSCRIPTION_ERROR';
export const CLEAR_CHANNELS_SUBSCRIPTION_ERROR = 'CLEAR_CHANNELS_SUBSCRIPTION_ERROR';

export const sendChannelSubscriptionMail = channelId => {
  return { type: SEND_SUBSCRIPTION_MAIL, channelId };
};
